import { entities } from "sbtech-sports-data-api-client";
import * as Models from "../../Models";
import { getCurrentTime } from "sb-resp-lib"
import { MarketsObject } from "../../../Interfaces";

export enum VenuRole {
    Home = "Home",
    Away = "Away",
}

export class EventParser {

    public static parse(newEvent: entities.SportEvent, currentTimeZone, sortId: string, eventMarketsIds: string[]): Models.Event {

        let marketsIds: string[] = [];

        // ugly code due to wrong entity property type
        marketsIds = eventMarketsIds;
        let convertedDate = Date.fromISO(newEvent.startEventDate);
        let eventDate = convertedDate ? getCurrentTime(convertedDate, currentTimeZone) : undefined;
        let eventStartingDate = eventDate ? eventDate.formatDate("dd/MM") : "--";
        let eventStartingTime = eventDate ? eventDate.formatDate("HH:mm") : "--";

        let names = this.mapParticipantsNames(newEvent);

        return new Models.Event({
            eventName: newEvent.eventName ? newEvent.eventName : "",
            sportName: newEvent.sportName,
            sportSortId: newEvent.sportOrder.toString(),
            sortId,
            marketLinesCount: newEvent.marketLinesCount,
            sportId: newEvent.sportId,
            leagueId: newEvent.leagueId,
            participant1Name: names.participant1,
            participant2Name: names.participant2,
            marketIds: marketsIds,
            id: newEvent.id,
            leagueName: newEvent.leagueName,
            eventStartingDate,
            eventStartingTime,
            eventDate: newEvent.startEventDate,
            isTeamSwapEnabled: newEvent.isTeamSwap,
            personalizedSortId: "",
            linkAddress: ""
        })
    }

    public static getFilteredMarketIds(newEvent: entities.SportEventChange, markets: MarketsObject) {
        let marketsIds: string[] = [];

        for (var key in markets) {
            if (markets.hasOwnProperty(key)) {
                let market = markets[key];
                if (market.eventId === newEvent.id)
                {
                    marketsIds.push(market.id);
                }
            }
        }

        return marketsIds;
    }

    public static getParticipantName(newEvent: entities.SportEvent, index: number) {
        const venueRole = index === 0 ? VenuRole.Home : VenuRole.Away;

        let participant = newEvent.participants.find((par) => par.venueRole === venueRole);
        let participantName = (participant) ?
            participant.name :
            (newEvent.participants[index] ? newEvent.participants[index].name : "");

        return participantName;
    }

    private static mapParticipantsNames(newEvent: entities.SportEvent) {
        const names = {
            participant1: "",
            participant2: ""
        }
        const swapPositions = newEvent.isTeamSwap ? [1, 0] : [0, 1];

        names.participant1 = this.getParticipantName(newEvent, swapPositions[0]);
        names.participant2 = this.getParticipantName(newEvent, swapPositions[1]);

        return names;
    }
}
